import api from '../../api/restaurant/restaurantProductionPlannerApi';
import type {
  ProductionBatch,
  ProductionPlannerResponse,
  ProductionRequest,
  ProductionBatchFilters,
  ProductionBatchPage,
  ProductionSuggestionFilters,
  ProductionSuggestionPage,
} from '../../types/restaurant/RestaurantProductionPlannerTypes';
import { appendRestaurantQuery } from './restaurantPageQuery';

const branchPath = (branchId: number) => `/branches/${branchId}`;

const RestaurantProductionPlannerService = {
  suggestions: async (
    branchId: number,
    filters: ProductionSuggestionFilters
  ) => {
    const query = appendRestaurantQuery(
      new URLSearchParams({
        source: filters.source,
        page: String(filters.page),
        size: String(filters.size),
      }),
      {
        purchaseId:
          filters.source === 'INVENTORY' ? undefined : filters.purchaseId,
        search: filters.search?.trim(),
        categoryId: filters.categoryId,
      }
    );
    return (
      await api.fetchCustom(`${branchPath(branchId)}/suggestions?${query}`)
    ).data as ProductionSuggestionPage;
  },
  produce: async (branchId: number, request: ProductionRequest) =>
    (
      await api.addCustom(`${branchPath(branchId)}/produce`, {
        ...request,
        items: request.items.map((item) => ({
          ...item,
          quantity: String(item.quantity),
        })),
      })
    ).data as ProductionPlannerResponse<ProductionBatch>,
  history: async (
    branchId: number,
    filters: ProductionBatchFilters
  ) => {
    const query = appendRestaurantQuery(
      new URLSearchParams({
        page: String(filters.page),
        size: String(filters.size),
      }),
      {
        search: filters.search?.trim(),
        source: filters.source,
        status: filters.status,
        dateFrom: filters.dateFrom,
        dateTo: filters.dateTo,
      }
    );

    return (await api.fetchCustom(`${branchPath(branchId)}/batches?${query}`))
      .data as ProductionBatchPage;
  },
  getBatch: async (branchId: number, batchId: number) =>
    (await api.fetchCustom(`${branchPath(branchId)}/batches/${batchId}`))
      .data as ProductionPlannerResponse<ProductionBatch>,
};

export default RestaurantProductionPlannerService;

// Adaptador deliberadamente sin UI para que Sprint 4 pueda reutilizar el motor.
export const planRestaurantOrderProduction =
  RestaurantProductionPlannerService.suggestions;
export const produceRestaurantOrderBatch =
  RestaurantProductionPlannerService.produce;
